import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button, Card, Cell, DeprecatedIcon } from '@vinted/web-ui';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { SearchBarSearchType } from 'constants/search';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SEARCH_TYPES = [SearchBarSearchType.Item, SearchBarSearchType.User, SearchBarSearchType.Forum, SearchBarSearchType.Faq];
const SELECTOR_DROPDOWN_WIDTH = 150;

const mapStateToProps = state => ({
  isForumDisabled: getIsFeatureSwitchEnabled('disable_forum_web')(state)
});

const connector = connect(mapStateToProps);

class TypeSelector extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "translate", id => this.props.intl.formatMessage({
      id: "searchbar.".concat(id)
    }));

    _defineProperty(this, "handleButtonClick", () => {
      if (this.props.onClick) this.props.onClick();
    });

    _defineProperty(this, "handleTypeClick", searchType => () => {
      if (this.props.onSelect) this.props.onSelect(searchType);
    });
  }

  renderDropdown(searchTypes) {
    if (!this.props.isOpen) return null;
    return /*#__PURE__*/_jsx("div", {
      className: "u-ui-margin-top-regular u-position-absolute",
      style: {
        width: SELECTOR_DROPDOWN_WIDTH
      },
      children: /*#__PURE__*/_jsx(Card, {
        children: /*#__PURE__*/_jsx("div", {
          className: "u-overflow-hidden",
          children: searchTypes.map(type => /*#__PURE__*/_jsx(Cell, {
            type: Cell.Type.Navigating,
            styling: Cell.Styling.Narrow,
            onClick: this.handleTypeClick(type),
            testId: "search-bar-search-type-".concat(type),
            children: this.translate("types.".concat(type))
          }, type))
        })
      })
    });
  }

  render() {
    const {
      isForumDisabled
    } = this.props;
    const searchTypes = isForumDisabled ? SEARCH_TYPES.filter(type => type !== SearchBarSearchType.Forum) : SEARCH_TYPES;
    const searchType = searchTypes.find(type => type === this.props.selectedType);
    if (!searchType) return null;
    return /*#__PURE__*/_jsxs("div", {
      className: "u-position-relative",
      children: [/*#__PURE__*/_jsx(Button, {
        text: /*#__PURE__*/_jsx("span", {
          id: "search-".concat(searchType),
          children: this.translate("types.".concat(searchType))
        }),
        styling: Button.Styling.Flat,
        size: Button.Size.Medium,
        theme: "muted",
        deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
          name: "dropdown",
          size: DeprecatedIcon.Size.Small,
          color: DeprecatedIcon.Color.GreyscaleLevel3
        }),
        iconPosition: Button.IconPosition.Right,
        onClick: this.handleButtonClick,
        testId: "search-bar-search-type",
        aria: {
          'aria-expanded': this.props.isOpen
        }
      }), this.renderDropdown(searchTypes)]
    });
  }

}

_defineProperty(TypeSelector, "defaultProps", {
  isOpen: false,
  selectedType: SearchBarSearchType.Item,
  onClick: null,
  onSelect: null
});

export default connector(injectIntl(TypeSelector));